import type { CareEvent } from "api/models/CareEvent";
import type { MedicalReferral } from "api/models/MedicalReferral";

export const isReferral = (record: MedicalReferral | CareEvent): record is MedicalReferral =>
  Object.hasOwnProperty.call(record, "doctor_name");
export const isCareEvent = (record: MedicalReferral | CareEvent): record is CareEvent =>
  Object.hasOwnProperty.call(record, "health_care_professional_name");
